import { cloneDeep } from 'lodash-es';
import { useMemo } from 'react';
import { useFlattenMenu, useMenu } from 'src/Shared/Hooks/MenuHooks';
import { addFavouriteToMenu } from 'src/Shared/Utilities/Menu';
import { useGetFavouriteReportsQuery } from 'src/app/standaloneSlices/apiSlice';
import { IFavouriteReport } from 'src/app/standaloneSlices/commonModels';
import { IMenuItem } from 'src/feature/Menu/menuModels';

export function UseGetFavouriteReports(): IFavouriteReport[] {
  const { data: favouriteReportsFromServer } = useGetFavouriteReportsQuery();
  // const menu = useSelector(getFlattenMenuData);
  const menu = useFlattenMenu();
  const tmp = useMemo(
    () =>
      Array.isArray(favouriteReportsFromServer)
        ? favouriteReportsFromServer?.reduce((result: IFavouriteReport[], reportfromServer) => {
            const menuItem = menu.find((item) => item.Name === reportfromServer.ReportName);
            if (menuItem) {
              result.push(Object.assign({}, reportfromServer, menuItem));
            }
            return result;
          }, [])
        : [],
    [menu, favouriteReportsFromServer],
  );
  return tmp;
}

export function UseGetMenuWithFavourite(): IMenuItem[] {
  const { data: favouriteReportsFromServer } = useGetFavouriteReportsQuery();
  // const menu = useSelector(getMenuData);
  const menu = useMenu();
  return useMemo(() => {
    const newMenuData = cloneDeep(menu);
    if (favouriteReportsFromServer) {
      addFavouriteToMenu(newMenuData, favouriteReportsFromServer);
    }
    return newMenuData;
  }, [favouriteReportsFromServer, menu]);

  // return newMenuData;
}
